// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-q_gj","advertDetailParameterList__header":"c-q_gk","advertDetailParameterList__list":"c-q_gl"};